import { App } from 'vue';
import Icon from './src/index.vue';
import './src/iconfont';

Icon.install = (app: App): void => {
    app.component(Icon.name, Icon);
};

export default Icon;

declare module 'vue' {
  export interface GlobalComponents {
      PtIcon: typeof Icon;
  }
}
